export default "__VITE_ASSET__CRuJaSFq__"